import { render, staticRenderFns } from "./newUser_en.vue?vue&type=template&id=55c7dea2&"
import script from "./newUser_en.vue?vue&type=script&lang=js&"
export * from "./newUser_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports